export default __webpack_public_path__ + "static/media/Animals-22.82e5e166.png";